export const APP_VERSION = '1.51.1';

export type EnvironmentName = 'dev' | 'qa' | 'livet' | 'uat' | 'prod';

export const API_GATEWAY_BASE_URLS: Record<EnvironmentName, string> = {
  dev: 'http://57.155.177.157',
  qa: 'https://gateway.qa.mycixor.com',
  livet: 'http://172.188.207.123',
  uat: 'https://api-uat.finap-usa.com',
  prod: 'https://gateway.prod.mycixor.com',
};
